module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"send":"Send","placeholder":"Enter your message","chatTitle":"Chat"}}')
  delete Component.options._Ctor
}
